// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3bkl1","text":"SelectPayment_text__23Rpb","title":"SelectPayment_title__5icy1","btn":"SelectPayment_btn__4lFLn"};